module.exports = __webpack_public_path__ + "static/media/language.6f873b46.png";